import { render, staticRenderFns } from "./OneTimeDiscountTabs.vue?vue&type=template&id=3ece6f9a&scoped=true&"
import script from "./OneTimeDiscountTabs.vue?vue&type=script&lang=js&"
export * from "./OneTimeDiscountTabs.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./OneTimeDiscountTabs.vue?vue&type=style&index=1&id=3ece6f9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ece6f9a",
  null
  
)

export default component.exports